import { render, staticRenderFns } from "./ConfirmDlg.vue?vue&type=template&id=3764de90&scoped=true"
import script from "./ConfirmDlg.vue?vue&type=script&lang=js"
export * from "./ConfirmDlg.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDlg.vue?vue&type=style&index=0&id=3764de90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3764de90",
  null
  
)

export default component.exports